<template>
  <div class="admin-dashboard-page" @click="handleOutsideClick">
    <div class="full-wrapper">
      <div class="main-custom-row">
        <div class="main-left">
          <div class="top-info-filters">
            <div class="custom-row">
              <h1>
                {{ constants.DASHBOARD_TEXT }}
              </h1>
            </div>
          </div>
          <div class="dashboard-customer-project mt-25">
            <ProjectsList></ProjectsList>
          </div>
          <div class="dashboard-project-status">
            <ProjectStatus></ProjectStatus>
          </div>
          <div class="dashboard-chart-2">
            <div class="custom-row">
              <Chart1></Chart1>
              <Chart2></Chart2>
            </div>
          </div>
          <div class="dashboard-chart-full">
            <Chart3></Chart3>
          </div>
        </div>
        <div class="main-right">
          <Issues ref="issuesRef"></Issues>
          <Activity ref="activityRef"></Activity>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import constants from "@/utils/en-US-Employee.json";
import ProjectsList from "@/components/lems-v1/projectsList.vue";
import ProjectStatus from "@/components/lems-v1/projectStatus.vue";
import Chart1 from "@/components/lems-v1/chart1.vue";
import Chart2 from "@/components/lems-v1/chart2.vue";
import Chart3 from "@/components/lems-v1/chart3.vue";
import Issues from "@/components/lems-v1/issues.vue";
import Activity from "@/components/lems-v1/activity.vue";

export default defineComponent({
  name: "Dashboard",
  components: {
    ProjectsList,
    ProjectStatus,
    Chart1,
    Chart2,
    Chart3,
    Issues,
    Activity,
  },
  data() {
    return {
      constants,
    };
  },
  methods: {
    handleOutsideClick(event: MouseEvent) {
      const target = event.target as HTMLElement;
      
      const isCalendarClick = target.closest('.calendar-drop-down-box') || 
                             target.closest('.calendar-drop-down-icon') ||
                             target.closest('.calendar-drop-down-content');
      
      if (!isCalendarClick) {
        this.closeAllCalendars();
      }
    },
    closeAllCalendars() {
      if (this.$refs.issuesRef && (this.$refs.issuesRef as any).closeCalendar) {
        (this.$refs.issuesRef as any).closeCalendar();
      }
      
      if (this.$refs.activityRef && (this.$refs.activityRef as any).closeCalendar) {
        (this.$refs.activityRef as any).closeCalendar();
      }
    }
  }
});
</script>
